/**
 * Which state NS Assistant's avatar shows, and the words that go with it.
 *
 * Read entirely from state the page already has: the page phase from
 * `useBusinessAssessment`, and the agent's own `lk.agent.state` participant
 * attribute that LiveKit publishes as the pipeline moves between listening,
 * thinking and speaking. Nothing is inferred from audio levels, so the avatar
 * never shows activity that is not actually happening.
 */

import { PHASES } from './useBusinessAssessment';

export function avatarState({ phase, agentState, agentPresent, isPaused, micEnabled }) {
  if (phase === PHASES.REQUESTING_MIC) {
    return { key: 'connecting', label: 'Waiting for microphone access…' };
  }
  if (phase === PHASES.CONNECTING) {
    return { key: 'connecting', label: 'Connecting…' };
  }
  if (phase === PHASES.FINISHING) {
    return agentState === 'speaking'
      ? { key: 'speaking', label: 'Speaking…' }
      : { key: 'idle', label: 'Wrapping up…' };
  }
  if (isPaused) {
    return { key: 'paused', label: 'Paused' };
  }
  // No published state yet means NS Assistant has not joined, or is starting.
  if (!agentPresent || !agentState || agentState === 'initializing') {
    return { key: 'connecting', label: 'Connecting…' };
  }
  if (agentState === 'speaking') {
    return { key: 'speaking', label: 'Speaking…' };
  }
  if (agentState === 'thinking') {
    return { key: 'thinking', label: 'Thinking…' };
  }
  if (agentState === 'listening') {
    return micEnabled
      ? { key: 'listening', label: 'Listening…' }
      : { key: 'idle', label: 'Microphone muted' };
  }
  return { key: 'idle', label: 'Ready' };
}
